<template>
    <div class="table-cell sticky-column border-right" @contextmenu.prevent="onCellClick">
        <a v-if="field.field_type === 'Text'" href="javascript:void(0)" @click="onDocumentClick">
            <div class="rich-text mb-1">
                <div v-html="document[field.index]"></div>
            </div>
        </a>

        <a v-else href="javascript:void(0)" @click="onDocumentClick">{{document[field.index]}}</a>
    </div>
</template>

<script>
    export default {
        name: 'PrimaryCell',
        props: ['field', 'document'],
        data() {
            return {
                model: webase.model
            }
        },
        methods: {
            onCellClick(event) {
                this.$emit('cellCtrlClick', event, this.document)
            },
            onDocumentClick() {
                this.$emit('documentClicked', this.document)
            }
        }
    }
</script>

